export function debug(message: string) {
  return;
}
export function info(message: string) {
  return;
}
export function error(message: Error | string | unknown) {
  return;
}
export const logger = {
  debug,
  info,
  error,
};
